import React, { type PropsWithChildren } from 'react';

import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import { Box } from '@atlaskit/primitives/compiled';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { CommentAuthor } from '@confluence/inline-comments-common/entry-points/CommentAuthor.ts';
import { WithCurvedBranchingStyle } from '@confluence/inline-comments-common/entry-points/components.ts';

const styles = cssMap({
	editorContainer: {
		width: '100%',
	},
});

const curvedBranchingStyle = {
	height: token('space.200'),
};

const longerCurvedBranchingStyle = {
	height: token('space.200'),
	top: token('space.negative.100'),
};

type RepliesFooterEditorProps = {
	numOfVisibleReplies: number;
};

export const RepliesFooterEditor = ({
	children: replyEditor,
	numOfVisibleReplies,
}: PropsWithChildren<RepliesFooterEditorProps>) => {
	const { userId } = useSessionData();

	return (
		<>
			<WithCurvedBranchingStyle
				showDefaultStyles
				customStyles={numOfVisibleReplies === 0 ? longerCurvedBranchingStyle : curvedBranchingStyle}
			>
				<CommentAuthor size="small" commentMode="create" userId={userId} />
			</WithCurvedBranchingStyle>
			<Box testId="reply-editor-container" xcss={styles.editorContainer}>
				{replyEditor}
			</Box>
		</>
	);
};
